import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {ErrorOutlineOutlined } from '@material-ui/icons';
import MasterPage from 'components/MasterPage';

const UnauthorizedAccess = () => {
  return (
    <>
      <Container>
        <Row className="justify-content-center my-4">
          <Card.Body className="shadow bg-white rounded text-center m-2 col-lg-6 pt-5">
            <Row className="text-center">
              <Col xs="12">
                <ErrorOutlineOutlined className="icon-title" />
                <h5 className="title-dashboard">Atenção!</h5>
              </Col>
            </Row>
            <Row>
              <Col className="col-12 align-self-center p-3">
                <h4 className="text-black mb-4 px-4">Acesso não autorizado.</h4>                
              </Col>
            </Row>
          </Card.Body>        
        </Row>
      </Container>
    </>
  );
};

export default MasterPage(UnauthorizedAccess);
